import React, {Fragment, useEffect, useRef, useState} from 'react'
import {Dialog, Disclosure, Menu, Transition} from '@headlessui/react'

import axios, * as others from 'axios';
import {useLoaderData, useLocation, useParams} from "react-router-dom";
import { NumericFormat } from 'react-number-format';
import {
    adminActionCard,
    changeAttribute,
    editrequestCard,
    getAttribute,
    getImageWithPrefix,
    getLocalDate, handleEditrequestCard,
    hasAttribute,
    receiptCard,
    setAttribute,
    setRoomAttribute,
    smallArtistCard,
    smallEventCard,
    smallVenueCard
} from "../../components/common/utilities";
import ContentEditable from "react-contenteditable";
import PropertyNavigation from "../../components/common/navigation.component";
import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader'
import MainNavigation from "../../components/common/navigation.component";
import {DateTimePicker, LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment'
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import 'moment/locale/en-gb';
import {XMarkIcon} from "@heroicons/react/24/outline";
import FindVenues from "../../pages/venues/findVenues";

import { CheckIcon } from '@heroicons/react/20/solid'


export default function ListActionItems({eventid,artistid,venueid}) {
    let params = useParams();
    const data = useLoaderData() as any;
    console.log("params", params);
    let eventID = params.eventid;

    const [actionitems, setActionItems] = useState<any[]>([]);

    const getActionItems = async () => {

        axios.post(`${process.env.REACT_APP_API_URL}/p/manage/listbyattribute.do`, {
                ticket: localStorage.getItem('ticket'),
                event: eventid,
                artist: artistid,
                venue: venueid,


        },{
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(function (response) {
            // handle success
            setActionItems(response.data.collection);

        });
    }

    useEffect(() => {

        getActionItems();
        //getPhotos();
        //handleArtists(data);

    }, []);

    const showCard = (event,counter) => {

        if(hasAttribute(event,"adPackage"))
        {
            return receiptCard(event);
        }
        else if(hasAttribute(event,"editrequest"))
        {
            return handleEditrequestCard(event);
        }
        return null;
    }


    return (<div className="bg-white py-4 sm:py-6">
            {actionitems && actionitems.map((item,index) => (
                <>
                    {showCard(item,index)}
                </>
            ))}

        </div>

    )
}
